import { CartState } from '@src/infrastructure/storage/cartStore';
import { Serializer } from '../serializer';
import { Storage } from './storage';

export class LocalStorage implements Storage {
    private readonly serializer: Serializer;

    constructor() {
        this.serializer = new Serializer;
    }

    async set(cart: CartState) {
        if (!window.localStorage) {
            return;
        }
        const cartSerialized = this.serializer.serialize(cart);
        window.localStorage.setItem('cart', cartSerialized);
    }

    async get(): Promise<CartState> {
        if (!window.localStorage) {
            return;
        }
        const cartSerialized = window.localStorage.getItem('cart');
        return this.serializer.deserialize(cartSerialized);
    }
}